import { useFormContext, useWatch } from "react-hook-form";

import { MESSAGE } from "@/constants/message";
import { useDebouncedCatchmentSync } from "@/hooks/spatialAnalysis/useDebouncedCatchmentSync";
import { setCatchmentSettingsTemp } from "@/store/slice/spatialSlice";

import { CatchmentSettingsFormValues } from "../catchmentSettings";
import InputEntry from "./inputEntry";

const TEST_ID_PREFIX = "catchment-by-radius";

const CatchmentByRadius = () => {
  const form = useFormContext<CatchmentSettingsFormValues>();

  const radius = useWatch({ name: "radiusData", control: form.control });

  const debouncedSyncRadius = useDebouncedCatchmentSync(
    setCatchmentSettingsTemp
  );

  return (
    <div className="flex flex-col gap-3 items-center">
      <InputEntry
        maxItem={3}
        showTrashIcon={radius?.length > 1}
        fieldName="radiusData"
        placeHolder={MESSAGE.COVERAGE_TYPE.PLACEHOLDER_TYPE_RADIUS}
        onChange={() => debouncedSyncRadius("radiusData")}
        testId={TEST_ID_PREFIX}
      />
    </div>
  );
};

export default CatchmentByRadius;
